import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, renderSlot as _renderSlot, withCtx as _withCtx, normalizeClass as _normalizeClass, Fragment as _Fragment, createTextVNode as _createTextVNode, renderList as _renderList } from "vue"

const _hoisted_1 = { class: "product-card-header" }
const _hoisted_2 = { class: "product-number-row row align-center" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "title-row row q-my-sm justify-between" }
const _hoisted_5 = {
  key: 0,
  class: "product-price price-input q-my-sm"
}
const _hoisted_6 = {
  key: 0,
  class: "computed-price-tag has-tooltip",
  "data-tooltip": `Prices for this channel are managed by a pricing service`
}
const _hoisted_7 = {
  key: 1,
  class: "product-price"
}
const _hoisted_8 = {
  key: 0,
  class: "row items-center justify-between"
}
const _hoisted_9 = {
  key: 0,
  class: "product-price price-input q-my-sm"
}
const _hoisted_10 = {
  class: "computed-price-tag has-tooltip",
  "data-tooltip": `Prices for this channel are managed by a pricing service`
}
const _hoisted_11 = { class: "product-card-contents q-mt-md" }
const _hoisted_12 = { class: "sku title-row q-mb-xs" }
const _hoisted_13 = { class: "ean title-row q-mb-xs" }
const _hoisted_14 = { class: "variants q-mb-md" }
const _hoisted_15 = { class: "product-link q-mb-md" }
const _hoisted_16 = { class: "content" }
const _hoisted_17 = {
  key: 0,
  class: "components q-mb-md"
}
const _hoisted_18 = { class: "components" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = {
  key: 1,
  class: "components q-mb-md empty"
}
const _hoisted_21 = { class: "delete" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_status_icon = _resolveComponent("status-icon")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_toggle_new = _resolveComponent("toggle-new")!
  const _component_clipable = _resolveComponent("clipable")!
  const _component_barcode_icon = _resolveComponent("barcode-icon")!
  const _component_barcode = _resolveComponent("barcode")!
  const _component_simple_link = _resolveComponent("simple-link")!
  const _component_print_icon = _resolveComponent("print-icon")!
  const _component_add_icon = _resolveComponent("add-icon")!
  const _component_close_icon = _resolveComponent("close-icon")!
  const _component_ozn_button = _resolveComponent("ozn-button")!
  const _component_product_card_component = _resolveComponent("product-card-component")!
  const _component_trash_icon = _resolveComponent("trash-icon")!
  const _component_chevron_left_icon = _resolveComponent("chevron-left-icon")!
  const _component_ExternalLinkIcon = _resolveComponent("ExternalLinkIcon")!
  const _component_q_expansion_item = _resolveComponent("q-expansion-item")!

  return (_openBlock(), _createBlock(_component_q_expansion_item, {
    class: _normalizeClass(["product-card-container col-4", { removing: _ctx.catProduct?.sys?.removing, unlinked: !_ctx.catProduct?.id, draft: _ctx.catProduct?.sys?.draft, editing: _ctx.catProduct?.sys?.editing }]),
    ref: "expansionItem",
    "expand-icon-toggle": "",
    modelValue: _ctx.expanded,
    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.expanded) = $event))
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_status_icon, {
            class: "product-status",
            type: _ctx.synced,
            display: "inline",
            tooltip: _ctx.statusTooltip
          }, null, 8, ["type", "tooltip"]),
          (!_ctx.expanded)
            ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.skuController?.display(_ctx.catProduct?.sku || '')), 1))
            : (_openBlock(), _createElementBlock("p", { key: _ctx.syncedAt }, _toDisplayString(_ctx.syncedAt), 1)),
          (_ctx.catProduct?.sys?.editing)
            ? (_openBlock(), _createBlock(_component_q_btn, {
                key: 2,
                class: "icon-undo-button",
                flat: "",
                rounded: "",
                color: "primary",
                label: "Undo changes",
                padding: "2px 6px",
                icon: "undo",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('cancel')))
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_4, [
          (_ctx.readonly || !_ctx.catProduct?.sys?.editing)
            ? (_openBlock(), _createElementBlock("h5", {
                key: 0,
                class: "card-title",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.startEditing({ expand: true })))
              }, _toDisplayString((_ctx.catProduct?.title || _ctx.product?.title || '').trim() || 'Product has no title'), 1))
            : (_openBlock(), _createBlock(_component_q_input, {
                key: 1,
                class: "title-input",
                clearable: "",
                dense: "",
                "model-value": (_ctx.catProduct?.title || _ctx.product?.title || '').trim(),
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.updateProductField('title', String($event || '').trim()))),
                placeholder: "Title"
              }, null, 8, ["model-value"])),
          _renderSlot(_ctx.$slots, "price-input-collapsed", {
            editing: _ctx.catProduct?.sys?.editing,
            startEditing: _ctx.startEditing,
            state: _ctx.state,
            product: _ctx.catProduct
          }, () => [
            (!!_ctx.pricing_manager_service)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  (!_ctx.state.expanded)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.currencySign) + " " + _toDisplayString(_ctx.catProduct?.price), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  (!_ctx.state.expanded)
                    ? (_openBlock(), _createBlock(_component_q_input, {
                        key: 0,
                        class: "price-input q-my-sm",
                        "model-value": _ctx.catProduct?.price,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.updateProductField('price', $event))),
                        type: "number",
                        mask: "#.##",
                        "fill-mask": "0",
                        autocomplete: "off",
                        "bg-color": "white",
                        "hide-bottom-space": "",
                        debounce: "100",
                        outlined: "",
                        dense: "",
                        "bottom-slots": "",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (!_ctx.catProduct?.sys?.editing ? _ctx.startEditing({ expand: true }) : null))
                      }, {
                        prepend: _withCtx(() => [
                          _createElementVNode("span", null, _toDisplayString(_ctx.currencySign), 1)
                        ]),
                        _: 1
                      }, 8, ["model-value"]))
                    : _createCommentVNode("", true)
                ])),
            (!_ctx.state.expanded)
              ? (_openBlock(), _createBlock(_component_toggle_new, {
                  key: 2,
                  "model-value": _ctx.catProduct?.active,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.updateProductField('active', $event, true, true))),
                  label: _ctx.catProduct?.active ? 'Active' : 'Inactive'
                }, null, 8, ["model-value", "label"]))
              : _createCommentVNode("", true)
          ], true)
        ]),
        (_ctx.state.expanded)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _renderSlot(_ctx.$slots, "price-input-expanded", {
                editing: _ctx.catProduct?.sys?.editing,
                startEditing: _ctx.startEditing,
                state: _ctx.state,
                product: _ctx.catProduct
              }, () => [
                (!!_ctx.pricing_manager_service)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.currencySign) + " " + _toDisplayString(_ctx.catProduct?.price), 1)
                      ])
                    ]))
                  : (_openBlock(), _createBlock(_component_q_input, {
                      key: 1,
                      class: "price-input",
                      "model-value": _ctx.catProduct?.price,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.updateProductField('price', $event))),
                      type: "number",
                      mask: "#.##",
                      "fill-mask": "0",
                      autocomplete: "off",
                      "bg-color": "white",
                      "hide-bottom-space": "",
                      debounce: "100",
                      outlined: "",
                      dense: "",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (!_ctx.catProduct?.sys?.editing ? _ctx.startEditing({ expand: true }) : null))
                    }, {
                      prepend: _withCtx(() => [
                        _createElementVNode("span", null, _toDisplayString(_ctx.currencySign), 1)
                      ]),
                      _: 1
                    }, 8, ["model-value"])),
                _createVNode(_component_toggle_new, {
                  readonly: _ctx.readonly,
                  "model-value": _ctx.catProduct?.active,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.updateProductField('active', $event, true, true))),
                  label: _ctx.catProduct?.active ? 'Active' : 'Inactive'
                }, null, 8, ["readonly", "model-value", "label"])
              ], true)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _cache[17] || (_cache[17] = _createElementVNode("h6", { class: "subtitle ean q-mr-md" }, "SKU", -1)),
          _createVNode(_component_clipable, {
            payload: _ctx.skuController?.display(_ctx.catProduct?.sku || '') || '...',
            message: "SKU copied to clipboard"
          }, null, 8, ["payload"]),
          (!_ctx.showBarcode)
            ? (_openBlock(), _createBlock(_component_q_btn, {
                key: 0,
                class: "barcode-icon",
                flat: "",
                round: "",
                color: "primary",
                padding: "1px",
                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.showBarcode = true))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_barcode_icon)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.catProduct?.sku && _ctx.showBarcode)
            ? (_openBlock(), _createBlock(_component_barcode, {
                key: 1,
                class: "sku-datamatrix",
                "model-value": _ctx.skuController ? _ctx.skuController.display(_ctx.catProduct.sku) : _ctx.catProduct.sku,
                format: "datamatrixrectangular",
                "bar-width": 15,
                "bar-height": 3,
                style: {"margin-top":"-23px"}
              }, {
                default: _withCtx(() => _cache[16] || (_cache[16] = [
                  _createElementVNode("div", { class: "placeholder" }, "...", -1)
                ])),
                _: 1
              }, 8, ["model-value"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_13, [
          _cache[18] || (_cache[18] = _createElementVNode("h6", { class: "subtitle ean q-mr-md" }, "EAN", -1)),
          (_ctx.expanded && _ctx.catProduct?.id && _ctx.product)
            ? (_openBlock(), _createBlock(_component_simple_link, {
                key: 0,
                id: _ctx.catProduct.id,
                displayField: "ean",
                store: [_ctx.product]
              }, null, 8, ["id", "store"]))
            : _createCommentVNode("", true),
          _createVNode(_component_print_icon, { class: "print-icon" })
        ]),
        _renderSlot(_ctx.$slots, "product-information", { product: _ctx.catProduct }, undefined, true),
        _cache[26] || (_cache[26] = _createElementVNode("div", { class: "row items-center justify-between" }, [
          _createElementVNode("h6", { class: "subtitle q-mb-xs" }, "Variants")
        ], -1)),
        _createElementVNode("div", _hoisted_14, [
          _renderSlot(_ctx.$slots, "variants", {
            productVariants: _ctx.variants ?? []
          }, () => [
            _cache[19] || (_cache[19] = _createElementVNode("div", null, null, -1))
          ], true),
          (!_ctx.readonly)
            ? (_openBlock(), _createBlock(_component_q_btn, {
                key: 0,
                unelevated: "",
                flat: "",
                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$emit('update:variant-dialog-active', _ctx.catProduct?.sys.id)))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_add_icon),
                  _cache[20] || (_cache[20] = _createElementVNode("span", null, "add variant", -1))
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("h6", {
            class: _normalizeClass(["subtitle", _ctx.catProduct?.id ? '' : 'warn'])
          }, _toDisplayString(_ctx.catProduct?.id ? 'Product Linked' : 'Product not linked'), 3),
          _createElementVNode("div", _hoisted_16, [
            (_ctx.readonly)
              ? (_openBlock(), _createBlock(_component_simple_link, {
                  key: 0,
                  id: _ctx.catProduct.id,
                  "display-field": "title",
                  medium: ""
                }, null, 8, ["id"]))
              : (_ctx.catProduct?.id && _ctx.product)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createVNode(_component_simple_link, {
                      id: _ctx.catProduct.id,
                      "display-field": "title",
                      medium: "",
                      to: `/products/${_ctx.catProduct.id}`,
                      store: [_ctx.product]
                    }, null, 8, ["id", "to", "store"]),
                    _createVNode(_component_close_icon, {
                      class: "unlink-icon",
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.updateProductField('id', null, true)))
                    })
                  ], 64))
                : (_openBlock(), _createBlock(_component_ozn_button, {
                    key: 2,
                    class: "minimal",
                    flat: "",
                    onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$emit('update:link-dialog-active', _ctx.catProduct?.sys.id))),
                    style: {"padding-left":"0"}
                  }, {
                    default: _withCtx(() => _cache[21] || (_cache[21] = [
                      _createTextVNode("Search for products to link →")
                    ])),
                    _: 1
                  }))
          ])
        ]),
        (_ctx.catProduct?.id && _ctx.stockItems?.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _createElementVNode("table", _hoisted_18, [
                _cache[22] || (_cache[22] = _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", {
                      colspan: "2",
                      style: {"width":"100%"}
                    }, [
                      _createElementVNode("h6", { class: "subtitle component" }, "Components")
                    ]),
                    _createElementVNode("td", { class: "stock" }, [
                      _createElementVNode("h6", { class: "subtitle stock" }, "Stock")
                    ])
                  ])
                ], -1)),
                (_ctx.stockItems?.length)
                  ? (_openBlock(), _createElementBlock("tbody", _hoisted_19, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stockItems, (component, i) => {
                        return (_openBlock(), _createBlock(_component_product_card_component, {
                          id: component.sys.id,
                          count: _ctx.stockLedger[component.sys.id] || '-',
                          component: component
                        }, null, 8, ["id", "count", "component"]))
                      }), 256))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_20, _cache[23] || (_cache[23] = [
              _createElementVNode("h6", { class: "subtitle component" }, "Components", -1),
              _createElementVNode("p", null, "Product has no components", -1)
            ]))),
        _createElementVNode("div", _hoisted_21, [
          (!_ctx.readonly)
            ? (_openBlock(), _createBlock(_component_q_btn, {
                key: 0,
                onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.$emit('remove-product', !_ctx.catProduct?.sys?.removing))),
                unelevated: "",
                rounded: "",
                outline: "",
                color: _ctx.catProduct?.sys?.removing ? 'primary' : 'error'
              }, {
                default: _withCtx(() => [
                  (!_ctx.catProduct?.sys?.removing)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createVNode(_component_trash_icon, {
                          class: "delete-icon",
                          left: ""
                        }),
                        _cache[24] || (_cache[24] = _createElementVNode("span", null, "Delete Product", -1))
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createVNode(_component_chevron_left_icon),
                        _cache[25] || (_cache[25] = _createElementVNode("span", null, "Undo Removal", -1))
                      ], 64))
                ]),
                _: 1
              }, 8, ["color"]))
            : _createCommentVNode("", true),
          ((_ctx.isLinkedToShopify && _ctx.catProduct.sys?.mirror_id && _ctx.storeUrl))
            ? (_openBlock(), _createBlock(_component_ExternalLinkIcon, {
                key: 1,
                onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.openMirrorUrl())),
                style: {"margin-right":"8px","cursor":"pointer"}
              }))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 3
  }, 8, ["modelValue", "class"]))
}